export default {
  title: 'Destek İletişim',
  form: {
    firstName: 'Adı',
    lastName: 'Soyadı',
    nickname: 'Takma Adı',
    phoneNumber: 'Telefon Numarası',
    email: 'E-posta',
    emailVerification: 'E-posta doğrulama',
    subject: {
      label: 'Konu',
      options: ['Hata', 'Fatura', 'Bağlantı', 'Geri bildirim', 'İyileştirme'],
    },
    message: 'Mesaj',
    button: 'Göndermek',
  },
  errors: {
    requiredField: 'Bu alan zorunludur.',
    sendFailed: 'Hata oluştu, daha sonra tekrar deneyiniz',
  },
  success: {
    title: 'Anladım!',
    message: 'Bir destek temsilcimiz en kısa süre içinde size geri dönüş yapacaktır.',
  },
};
